import type { SVGProps } from 'react';
const SvgReplay5 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#replay_5_svg__a)">
      <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8Z" />
      <path d="m10.69 13.9.25-2.17h2.39v.71h-1.7l-.11.92c.03-.02.07-.03.11-.05.04-.02.09-.04.15-.05.06-.01.12-.03.18-.04a1.35 1.35 0 0 1 .75.08c.16.07.3.16.41.28.11.12.2.27.25.45.05.18.09.38.09.6 0 .19-.03.37-.09.54-.06.17-.15.32-.27.45-.12.13-.27.24-.45.31s-.39.12-.64.12c-.18 0-.36-.03-.53-.08-.17-.05-.32-.14-.46-.24a1.1 1.1 0 0 1-.32-.39c-.08-.15-.13-.33-.13-.53h.84c.02.18.08.32.19.41.11.09.25.15.42.15a.49.49 0 0 0 .45-.23c.04-.07.08-.15.11-.25s.03-.2.03-.31c0-.11-.01-.21-.04-.31a.618.618 0 0 0-.13-.24.51.51 0 0 0-.21-.15.896.896 0 0 0-.3-.05c-.08 0-.15.01-.2.02a.66.66 0 0 0-.15.05c-.04.02-.08.05-.12.07-.04.02-.07.06-.1.09l-.67-.16Z" />
    </g>
    <defs>
      <clipPath id="replay_5_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgReplay5;
